const SESSION_KEY = 'scharfenstein_newsletter_popup_seen';

function hasBeenShownThisSession() {
  try {
    return window.sessionStorage.getItem(SESSION_KEY) === 'true';
  } catch {
    return false;
  }
}

function rememberPopup() {
  try {
    window.sessionStorage.setItem(SESSION_KEY, 'true');
  } catch {
    // The popup still works when storage is unavailable.
  }
}

function openNewsletterPopup(popup) {
  const dialog = popup.querySelector('dialog');
  if (!dialog || dialog.open) return;

  rememberPopup();
  if (typeof dialog.showModal === 'function') {
    dialog.showModal();
  } else {
    dialog.setAttribute('open', '');
  }
}

function initializeNewsletterPopup(popup) {
  const dialog = popup.querySelector('dialog');
  const closeButton = popup.querySelector('[ref="closeButton"]');
  if (!dialog) return;

  closeButton?.addEventListener('click', () => {
    console.log(dialog.close);
    // rememberPopup();
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  });

  // dialog.addEventListener('close', rememberPopup);

  if (popup.hasAttribute('initial-form-open')) {
    openNewsletterPopup(popup);
    return;
  }

  if (hasBeenShownThisSession()) return;

  const delaySeconds = Number.parseInt(popup.dataset.sessionDelay || '5', 10);
  window.setTimeout(() => openNewsletterPopup(popup), Math.max(delaySeconds, 0) * 1000);
}

function initializeNewsletterPopups() {
  document.querySelectorAll('hdt-newsletter-popup[data-session-popup]').forEach(initializeNewsletterPopup);
}

if (document.readyState === 'loading') {
  // document.addEventListener('DOMContentLoaded', initializeNewsletterPopups, { once: true });
} else {
  initializeNewsletterPopups();
}
